import { render, staticRenderFns } from "./RequestUpdate.vue?vue&type=template&id=3bcbd571&scoped=true&"
import script from "./RequestUpdate.vue?vue&type=script&lang=ts&"
export * from "./RequestUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./RequestUpdate.vue?vue&type=style&index=0&id=3bcbd571&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcbd571",
  null
  
)

export default component.exports